import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M22.214 14.41h-4.62a5.5 5.5 0 0 1-2.718-.722l-2.608-1.493a7.2 7.2 0 0 0-1.666-.684A5.885 5.885 0 0 0 3.893 1.88a5.877 5.877 0 0 0-2.066 8.069c.289.488.646.932 1.06 1.32h-1.1a.786.786 0 0 0-.785.785v7.857a.785.785 0 0 0 .786.786h20.426A.785.785 0 0 0 23 19.91v-4.714a.786.786 0 0 0-.786-.785M2.707 5.879A4.33 4.33 0 0 1 7.963 2.76a4.321 4.321 0 1 1-5.256 3.143zm18.722 13.246H2.573v-1.57h7.071a.786.786 0 0 0 0-1.572h-7.07v-3.143h6.19a5.5 5.5 0 0 1 2.718.723l2.609 1.493a7.1 7.1 0 0 0 3.504.927h3.834z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M7.185 9.516a.786.786 0 1 0 1.571 0 .786.786 0 0 0-1.571 0M6.76 8.259a.786.786 0 1 0 0-1.571.786.786 0 0 0 0 1.57M9.18 7.74a.786.786 0 1 0 0-1.571.786.786 0 0 0 0 1.571"
    }, null, -1)
  ]))]))
}
export default { render: render }